import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'name'];

  browse() {
    this.inputTarget.click();
  }

  update() {
    const [file] = this.inputTarget.files;

    if (file) this.nameTarget.textContent = file.name;
  }
}
